import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var clipboardPluginKey = new PluginKey('clipboardPlugin');